import { useMemo } from 'react'
import { AdvancedDateRangePicker } from '@/components/ui/AdvancedDateRangePicker'
import type { ResidentLeaseStartDateRangeFieldProps } from '../../types'
import {
  getResidentLeaseStartPresetRanges,
  parseResidentApiDate,
} from '../../utils/residentDateUtils'



/**
 * Lease start filter: same quick ranges and MM-dd-yyyy display as Angular resident list
 * (`ngx-daterangepicker-material`), with values still read/written as resident API `dd-MM-yyyy` via the parent.
 */
export function ResidentLeaseStartDateRangeField({
  fromDt,
  toDt,
  disabled,
  onRangeChange,
  className,
}: ResidentLeaseStartDateRangeFieldProps & { className?: string }) {
  const leasePresets = useMemo(() => getResidentLeaseStartPresetRanges(), [])

  return (
    <>
      <div
        data-testid="resident-list-filters-lease-start-picker-wrap"
        className="relative min-w-0 pill-filter-wrapper-vertical"
      >
        <AdvancedDateRangePicker
          startDate={parseResidentApiDate(fromDt)}
          endDate={parseResidentApiDate(toDt)}
          onChange={onRangeChange}
          placeholder="Select Date Range"
          presetsOnTop
          disabled={disabled}
          triggerClassName={className || 'h-12 min-h-12 rounded-xl border-slate-200 px-4'}
          displayRangeFormat="angularMmddyy"
          customPresets={leasePresets}
          monthsShown={2}
          stackMonthsVertically
          dropdownPortalToBody
          dropdownPortalZIndex={2147483647}
          dropdownPortalCenterInFilterDrawer
        />
      </div>
      {/* Same calendar chip styling as Invitee list filter drawer */}
      <style>{`
        .pill-filter-wrapper-vertical .custom-calendar-wrapper button {
          width: auto !important;
          min-height: auto !important;
          padding-left: 0 !important;
          background-color: transparent !important;
          border-color: transparent !important;
          border-radius: 9999px !important;
        }
        .pill-filter-wrapper-vertical .custom-calendar-wrapper button:hover {
          background-color: #f1f5f9 !important;
          border-color: transparent !important;
        }
      `}</style>
    </>
  )
}
